import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { NumberOnlyDirective } from './directives/number-only.directive';

import { TrackOrderApiServices } from '../shared/services/track.api.service'
import { NgxUiLoaderModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
import { HeaderComponent } from './components/header/header.component';
import { FormatDatePipe } from './directives/format-date.pipe';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#008A71',
  bgsOpacity: 1,
  bgsPosition: 'bottom-right',
  bgsSize: 40,
  bgsType: 'double-bounce',
  blur: 1,
  delay: 0,
  fgsColor: '#008A71',
  fgsPosition: 'center-center',
  fgsSize: 50,
  fgsType: 'fading-circle',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: 'rgba(255,255,255,0.7)',
  pbColor: '#008A71',
  pbDirection: 'ltr',
  pbThickness: 4,
  hasProgressBar: true,
  maxTime: -1,
  minTime: 500
};

@NgModule({
  declarations: [
    FormatDatePipe,
    NumberOnlyDirective
  ],
  imports: [
    CommonModule,
    HeaderComponent,
    RouterModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ToastrModule.forRoot(),
    FlexLayoutModule,
  ],
  exports: [
    CommonModule,
    HeaderComponent,
    ReactiveFormsModule,
    FlexLayoutModule,
    RouterModule,
    NgxUiLoaderModule,
    ToastrModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    FormatDatePipe,
    NumberOnlyDirective
  ],
  providers: []
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [
        TrackOrderApiServices
      ]
    };
  }
}
